//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

class Modal extends PolymerElement {
  static get template() {
    return html`
      <style>
        .show {
          display: flex !important;
        }
        .modal {
          display: none;
          position: fixed;
          z-index: 99;
          padding-top: 100px;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          overflow: auto;
          background-color: rgb(0, 0, 0);
          background-color: rgba(0, 0, 0, 0.4);
        }
        .modal-content {
          background-color: #fefefe;
          margin: auto;
          padding: 20px;
          border: 1px solid #888;
          max-height: 72%;
          border-radius: 8px;
          overflow-y: scroll;
          scrollbar-width: none;
          -ms-overflow-style: none;
          margin-top: 2%;
        }
        .modal-content::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
        .close {
          color: #aaaaaa;
          font-size: 28px;
          font-weight: bold;
        }
        .close:hover,
        .close:focus {
          color: #000;
          text-decoration: none;
          cursor: pointer;
        }
        h2 {
          margin: 0;
        }
        .header {
          display: flex !important;
          align-items: center;
          justify-content: space-between;
        }
        .space {
          margin-bottom: 30px;
        }
      </style>
      <div id="myModal" class="modal">
        <template is="dom-if" if="{{!isCustomContainer}}">
          <div class="modal-content" style$="width:[[width]]; margin-top:[[margin]];">
            <template is="dom-if" if="{{!isCustomHeader}}">
              <div class="header">
                <h2>{{title}}</h2>
                <template is="dom-if" if="{{!disabled}}">
                  <span class="close" on-click="handleCloseModal">&times;</span>
                </template>
              </div>
            </template>
            <!-- child component -->
            <slot name="child-component"></slot>
            <!-- child component -->
            <div class="space"></div>
          </div>
        </template>
        <template is="dom-if" if="{{isCustomContainer}}">
          <slot name="child-component"></slot>
        </template>
      </div>
    `;
  }

  static get properties() {
    return {
      isActive: {
        type: Boolean,
        notify: true,
      },
      title: {
        type: String,
      },
      width: {
        type: String,
        value: "45%",
      },
      disabled: {
        type: Boolean,
        value: false,
      },
      margin: {
        type: String,
        value: "2%",
      },
      isCustomHeader: {
        type: Boolean,
        value: false
      },
      isCustomContainer: {
        type: Boolean,
        value: false
      },
    };
  }

  handleCloseModal(e) {
    if (this.isActive) {
      this.isActive = false;
      this.$["myModal"].classList.remove("show");
    } else {
      this.isActive = true;
      this.$["myModal"].classList.add("show");
    }
  }

  activate(e) {
    e && e.preventDefault();
    this.$["myModal"].classList.add("show");
    this.isActive = true;
  }

  deactivate() {
    if(this.disabled) return;
    this.isActive = false;
    this.$["myModal"].classList.remove("show");
  }
}
customElements.define("modal-container", Modal);
